(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('PaperErrorDialogController', PaperErrorDialogController);

    PaperErrorDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PaperError', 'YieldCurveResults'];

    function PaperErrorDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PaperError, YieldCurveResults) {
        var vm = this;

        vm.paperError = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.yieldcurveresults = YieldCurveResults.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.paperError.id !== null) {
                PaperError.update(vm.paperError, onSaveSuccess, onSaveError);
            } else {
                PaperError.save(vm.paperError, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('moldovaYieldCurvesApp:paperErrorUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.settleDate = false;
        vm.datePickerOpenStatus.transDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
